import { newStorage } from './storage';

const notificationNonitoringTableStorage = newStorage(
  'TABLE_NOTIFICATION_NONITORING'
);

export default notificationNonitoringTableStorage;
